var map = {
	"./air-conditioner.svg": 1563,
	"./airplane.svg": 1564,
	"./airport.svg": 1565,
	"./approved.svg": 1566,
	"./aquapark.svg": 1567,
	"./arrow-answer-bubble.svg": 1568,
	"./arrow-back.svg": 1569,
	"./arrow-flight.svg": 1570,
	"./arrow-right-top.svg": 1571,
	"./arrow-right.svg": 1572,
	"./bar.svg": 1573,
	"./beach-surface-pebble.svg": 1574,
	"./beach-surface-platform.svg": 1575,
	"./beach-surface-sand-pebble.svg": 1576,
	"./beach-surface-sand.svg": 1577,
	"./beachsurface.svg": 1578,
	"./card.svg": 1579,
	"./check.svg": 1580,
	"./clock.svg": 1581,
	"./cvv.svg": 1582,
	"./double-arrow.svg": 1583,
	"./empty-hotel-map.svg": 1584,
	"./filters/clear-filters.svg": 1585,
	"./filters/filter-button.svg": 1586,
	"./filters/instant-confirm-colored.svg": 1587,
	"./filters/instant-confirm.svg": 1588,
	"./filters/search-distance.svg": 1589,
	"./filters/search-lift.svg": 1590,
	"./fire.svg": 1591,
	"./flight-direct-mobile.svg": 1592,
	"./flight-direct.svg": 1593,
	"./flight-direct__additional-mobile.svg": 1594,
	"./flight-direct__additional.svg": 1595,
	"./flight-transition-mobile.svg": 1596,
	"./flight-transition.svg": 1597,
	"./flight-transition__additional-mobile.svg": 1598,
	"./flight-transition__additional.svg": 1599,
	"./food.svg": 1600,
	"./free-cancellation-colored.svg": 1601,
	"./fuel-green.svg": 1602,
	"./fuel-white.svg": 1603,
	"./funicular.svg": 1604,
	"./gallery-empty.svg": 1605,
	"./garranty.svg": 1606,
	"./gender-female.svg": 1607,
	"./gender-male.svg": 1608,
	"./gender-unidentified.svg": 1609,
	"./gift.svg": 1610,
	"./glass.svg": 1611,
	"./gym.svg": 1612,
	"./hand-luggage.svg": 1613,
	"./heated-pool.svg": 1614,
	"./hold-luggage.svg": 1615,
	"./hotel-reply.svg": 1616,
	"./included-services.svg": 1617,
	"./included.svg": 1618,
	"./kids-club.svg": 1619,
	"./kids-menu.svg": 1620,
	"./kids-pool.svg": 1621,
	"./lightning.svg": 1622,
	"./lock.svg": 1623,
	"./logo.svg": 1624,
	"./lt-extra/bonus_insurance.svg": 1625,
	"./lt-extra/bonus_ivi.svg": 1626,
	"./luggage-wrapping.svg": 1627,
	"./man.svg": 1628,
	"./map-button.svg": 1629,
	"./map/collapse-arrows.svg": 1630,
	"./map/expand-arrows.svg": 1631,
	"./massage.svg": 1632,
	"./nanny.svg": 1633,
	"./only-lt-half.svg": 1634,
	"./parking.svg": 1635,
	"./payment-mir.svg": 1636,
	"./paymenttype.svg": 1637,
	"./plane-arrival.svg": 1638,
	"./plane.svg": 1639,
	"./private-beach.svg": 1640,
	"./rest_types/active.svg": 1641,
	"./rest_types/couples.svg": 1642,
	"./rest_types/family.svg": 1643,
	"./review-tab-selected.svg": 1644,
	"./sauna.svg": 1645,
	"./search-sorting.svg": 1646,
	"./searcher-empty-request.svg": 1647,
	"./searcher-filtered-empty.svg": 1648,
	"./sidebar-bottom-triangle.svg": 1649,
	"./sidebar-menu-active.svg": 1650,
	"./sign_additional.svg": 1651,
	"./ski-in-ski-out.svg": 1652,
	"./social-fb.svg": 1653,
	"./social-share.svg": 1654,
	"./social-vk.svg": 1655,
	"./special.svg": 1656,
	"./success_additional.svg": 1657,
	"./swimming-pool.svg": 1658,
	"./thumbs-up.svg": 1659,
	"./wave.svg": 1660,
	"./wifi.svg": 1661
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 979;